import React from 'react';
import { toast } from 'chameleon/ui-stack/ui/toast';
import './index.scss';

const UploadAnswerSheetsToast = () =>
  toast(
    <div className="UploadAnswerSheetsToast">
      <div>
        Answer sheets uploaded. Please allow up to 5 seconds for each page to be
        scanned.
      </div>
      <div>
        To view responses or the latest status, refresh your assignment page.
      </div>
    </div>,
    { timeout: 20 },
  );

export default UploadAnswerSheetsToast;
